export default __webpack_public_path__ + "static/media/DownArrow.dd2b98cd.svg";